import { useToast } from '@chakra-ui/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { featureFlagsKey, featureFlagsQueryOptions, toggleFeatureFlag } from './queries';
export const useFeatureFlags = (enabled = true) => useQuery(featureFlagsQueryOptions(enabled));
export const useToggleFeatureFlag = () => {
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationFn: (flag) => toggleFeatureFlag(flag.id),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: featureFlagsKey }),
        onError: err => {
            if (isAxiosError(err)) {
                toast({ title: err.response.data.message, status: 'error', duration: 4000, isClosable: true });
            }
        }
    });
};
